export default __webpack_public_path__ + "static/media/identity-outline-16px.8c9057ba.svg";